import React from 'react';
import PropTypes from 'prop-types';
import {
  StripeProvider,
  CardElement,
  Elements,
  injectStripe
} from 'react-stripe-elements';
import { UserAccountContext } from '../../../contexts/userAccount';
import { Panel } from '../../../components/Panel';
import noty from '../../../lib/noty';
import './style.scss';

export default class BillingInformation extends React.Component {
  render() {
    return (
      <UserAccountContext.Consumer>
        {({ onUpdateSubscription }) => (
          <StripeProvider apiKey={process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}>
            <Elements>
              <StripeCardForm
                onUpdateSubscription={onUpdateSubscription}
                currentAccount={this.props.currentAccount}
              />
            </Elements>
          </StripeProvider>
        )}
      </UserAccountContext.Consumer>
    );
  }
}

BillingInformation.propTypes = {
  currentAccount: PropTypes.object.isRequired
};

export class CardForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false
    };
  }

  handleSubmit = async event => {
    event.preventDefault();
    try {
      this.setState({ fetching: true });
      const { currentAccount, onUpdateSubscription } = this.props;
      const { error, token } = await this.props.stripe.createToken({
        name: currentAccount._id
      });
      if (error) {
        throw new Error(error.message);
      }
      const { message } = await currentAccount.updateCard(token);
      await onUpdateSubscription();
      noty.success(message);
    } catch (error) {
      noty.errors(error);
    } finally {
      this.setState({ fetching: false });
    }
  };

  render() {
    const { fetching } = this.state;
    return (
      <Panel
        onSaveClick={this.handleSubmit}
        saveTitle="Save Credit Card"
        fetching={fetching}
      >
        <div className="row margin-bottom-30">
          <div className="col-xs-12">
            <CardElement />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 ">
            <p>
              MapPlug uses industry leading payment technology and your credit
              card is never stored in our system. Emails will be automatically
              sent to the "Organization Email" regarding all biling information.
            </p>
          </div>
        </div>
      </Panel>
    );
  }
}

CardForm.propTypes = {
  currentAccount: PropTypes.object.isRequired,
  onUpdateSubscription: PropTypes.func.isRequired,
  stripe: PropTypes.object.isRequired
};

const StripeCardForm = injectStripe(CardForm);



// WEBPACK FOOTER //
// ./src/pages/Account/BillingInformation/index.jsx